import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FieldAnalyticsConfig} from '../../../models/field-config';
import {FormFieldService} from '../../../services/form-field.service';

@Component({
  selector: 'app-text-field-edit',
  templateUrl: './text-field-edit.component.html',
  styleUrls: []
})
export class TextFieldEditComponent implements OnInit {

  @Input() config: TextFieldEditConfig;
  @Output() onAction: EventEmitter<void> = new EventEmitter<void>();

  constructor(private formFieldService: FormFieldService) { }

  ngOnInit() {
  }

  onButtonClick() {
    this.formFieldService.onTextFieldEditActionClick(this.config);
    this.onAction.emit();
  }

}

export interface TextFieldEditConfig {
  fieldLabel: string;
  value: string;
  actionLabel?: string;
  analyticsConfig?: FieldAnalyticsConfig;
}
